/**
 * 功能: 显示竖版报告内容
 */
<template lang="pug">
  div.main()
    div#headerline
    el-container(style='height:100%')
      el-header.header
        Header(:headerData="headerData")
      el-container()
        el-main(style='color:black;')
          el-row()
            el-col(:span="12" :offset="6")
              template(v-for="menu in menuList")
                Content(:key="menu.name" :data="menu")
        el-aside.aside(:width="asideWidth + 'px'")
          outline(@showAside="showAside" :menuList="menuList" :list="illAndTable" :updateLog="updateLog")
      el-backtop
</template>

<script>
import Outline from './preview/outline'
import Content from './preview/content'
import Header from './preview/header'
import api from '@/apis/brief'
import apis from '@/apis/section'
import apiGlossary from '@/apis/glossary'
import apiImg from '@/apis/commuCore'

export default {
  components: { Outline, Content, Header },

  data () {
    return {
      asideWidth: 0,
      headerData: {},
      menuList: [],
      illAndTable: [],
      updateLog: []
    }
  },
  methods: {
    // 侧边栏 文章、目录、日志的显示
    showAside (e) {
      if (e) {
        this.asideWidth = 350
      } else {
        this.asideWidth = 0
      }
    },
    // 获取段落以及段落下的附件
    getSection (id) {
      apis.getSection({ id: id }).then(async res => {
        this.outLineData = res.data
        this.menuList.push(this.reWbsAndGraphic(res.data))
        this.illAndTable = this.creditLine(this.menuList[0])
        const requests = []
        for (const item of this.illAndTable) {
          if (item && item._class === 0) {
            requests.push(apiImg.downloadFile(this.GLOBAL.uploadHost + 'illustration/downloadUrl?url=' + item.hiImageUrl))
          }
        }
        const result = await Promise.all(requests)
        this.illAndTable.forEach(item => {
          if (item && item._class === 0) {
            item.newhiImageUrl = window.URL.createObjectURL(result.splice(0, 1)[0])
          }
        })
      })
    },
    // 获取报告信息
    getBrief (id) {
      api.getBrief({ id }).then(res => {
        this.headerData = res.data
      })
    },
    // 获取名词解释
    getGlossary (id) {
      apiGlossary.getGlossaryByBriefId({ brief: id }).then(r => {
        const glossaryArr = []
        r.data.map(glossary => {
          glossaryArr.push({ noun: glossary.noun, explanation: glossary.explanation })
        })
        glossaryArr.sort(function (item1, item2) {
          return item1.noun.localeCompare(item2.noun, 'zh-CN')
        })
        const glossarys = JSON.stringify(glossaryArr)
        sessionStorage.setItem('GLOSSARY', glossarys)
      })
    },
    // 重新生成wbs和图表目录序号
    reWbsAndGraphic (outlines, wbs = '', attachment = {}) {
      if (outlines && outlines.children.length > 0) {
        outlines.children.map((outline, index) => {
          outline.wbs = wbs + (index + 1) + '.'
          const desc = outline.wbs.split('.')[0]
          const keys = Object.keys(attachment)
          if (!keys.includes('ill' + desc)) {
            attachment['ill' + desc] = []
          }
          if (!keys.includes('table' + desc)) {
            attachment['table' + desc] = []
          }
          if (outline && outline.sections && outline.sections.length > 0) {
            outline.sections.map(section => {
              if (section && section.attachment.length > 0) {
                section.attachment.map(item => {
                  // 类型：0=图片，1=政策；2=Size；3=专家说
                  if (item._class === 0) {
                    attachment['ill' + desc].push(item)
                    item.explain = `图 ${desc}-${attachment['ill' + desc].length}`
                  } else if (item._class === 1) {
                    attachment['table' + desc].push(item)
                    item.explain = `表 ${desc}-${attachment['table' + desc].length}`
                  } else if (item._class === 2) {
                    const newItem = JSON.parse(JSON.stringify(item))
                    delete item.title
                    item.newTitle = newItem.title
                    attachment['ill' + desc].push(item)
                    item.explain = `图 ${desc}-${attachment['ill' + desc].length}`
                  }
                })
              }
            })
          }
          outline.children && this.reWbsAndGraphic(outline, outline.wbs, attachment)
        })
      }
      return outlines
    },
    // 获取图表目录
    creditLine (reportTree, list = []) {
      if (reportTree && reportTree.children.length > 0) {
        reportTree.children.map((outline, index) => {
          if (outline && outline.sections && outline.sections.length > 0) {
            outline.sections.map(section => {
              if (section && section.attachment.length > 0) {
                section.attachment.map(attr => {
                  if ((attr.senseless && attr._class === 0) || attr._class === 1 || attr._class === 2) {
                    list.push(attr)
                  }
                })
              }
            })
          }
          outline.children && this.creditLine(outline, list)
        })
      }
      return list
    }
  },
  created () {
    const id = this.$route.query.id
    if (id) {
      this.getSection(id)
      this.getBrief(id)
      this.getGlossary(id)
      api.getBriefLogList({ id }).then(doc => {
        this.updateLog = doc.data
      })
    }
  }
}
</script>

<style scoped>
body{
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, Arial, sans-serif;
}
.main {
  height: 100%;
}
.el-header {
  color: #333;
  text-align: center;
  line-height: 56px;
  padding: 0 0;
}
#headerline {
  width: 100%;
  height: 2px;
  background-color: red;
  position: fixed;
  top: 0;
}
.el-main {
  color: #333;
  line-height: auto;
}
body > .el-container {
  margin-bottom: 40px;
}
.aside {
  position: fixed;
  top: 62px;
  right: 0;
}
</style>
